import CommitCardSkeleton from './CommitCardSkeleton';

interface CommitThreadSkeletonProps {
  count?: number;
}

export default function CommitThreadSkeleton({ count = 3 }: CommitThreadSkeletonProps) {
  return (
    <div className="relative">
      {Array.from({ length: count }).map((_, index) => {
        const isLast = index === count - 1;

        return (
          <div key={index} className="relative flex gap-0 sm:gap-4">
            {/* Thread line connector - hidden on mobile */}
            <div className="hidden sm:flex flex-col items-center w-4 flex-shrink-0">
              {/* Dot */}
              <div className="w-2 h-2 rounded-full bg-[hsl(var(--muted-foreground))]/20 mt-5 z-10 animate-pulse" />
              {/* Vertical line */}
              {!isLast && (
                <div className="w-[2px] flex-1 bg-[hsl(var(--border))]/50 -mb-1" />
              )}
            </div>
            {/* Skeleton card */}
            <div className="flex-1 pb-6 sm:pb-4">
              <CommitCardSkeleton />
            </div>
          </div>
        );
      })}
    </div>
  );
}
